<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  kind: {
    type: String,
    required: true,
  },
  image: {
    type: Object,
  },
});
</script>

<template>
  <section class="section relative h-[75vh] flex justify-start items-end">
    <div class="w-full h-full absolute top-0 left-0 bg-chsc-indigo-500">
      <img
        v-if="image && image.filename"
        :src="image.filename"
        :alt="image.alt"
        class="w-full h-full object-cover"
      />
    </div>
    <UiContainer class="max-w-full w-full px-9">
      <h1 class="relative font-londrina-solid text-white fs-8xl">
        {{ title }}
      </h1>
    </UiContainer>
  </section>
</template>
